import * as React from "react";

export const NavLinkInfoPill = (props: { pillClass?: string, style?: any, value?: string, readable?: string }) => {
  if (props.value) {
    return (
      <span
        style={props.style}
        className={`pill${props.pillClass ? ' ' + props.pillClass : ''}`}
      >
        {props.readable &&
          <span className="visuallyhidden">. {props.readable}</span>
        }
        <span aria-hidden={props.readable?true:false}>{props.value}</span>
      </span>
    );
  } else {
    return null;
  }
}
